import { EditorView } from 'prosemirror-view'

/**
 * Returns the bounding client rect of the current selection. If the editor has focus, it returns the rect of the
 * dom selection. Otherwise returns the smallest rect that contains all .selectionMarker elements.
 */
function getSelectionBoundingRect(view: EditorView) {
  if (view.hasFocus()) {
    const range = window.getSelection()?.rangeCount === 1 && window.getSelection()?.getRangeAt(0)
    if (!range) {
      return
    }
    return range.getBoundingClientRect()
  }

  const rects = Array.from(view.dom.querySelectorAll('.selectionMarker')).map((el) => el.getBoundingClientRect())
  if (rects.length === 0) return
  const [first, ...rest] = rects
  return rest.reduce((acc, cur) => extendRect(acc, cur), first)
}

/**
 * Returns the smallest DOMRect that contains both given DOMRects.
 */
function extendRect(rect1: DOMRect, rect2: DOMRect) {
  const newTop = Math.min(rect1.top, rect2.top)
  const newLeft = Math.min(rect1.left, rect2.left)
  const newBottom = Math.max(rect1.bottom, rect2.bottom)
  const newRight = Math.max(rect1.right, rect2.right)
  return DOMRect.fromRect({ x: newLeft, y: newTop, width: newRight - newLeft, height: newBottom - newTop })
}

/**
 * Returns whether the current selection is in the viewport. For the purposes of the inline format bar we only care
 * about top and bottom.
 */
export function isSelectionVisible(view: EditorView) {
  const rect = getSelectionBoundingRect(view)
  if (rect == null) return rect
  return rect.bottom >= 40 && rect.top <= window.innerHeight - 40
}
